(() => {
  const VERSION = 'W11_EVENT_V1';
  const NS = 'myakm:';
  const SEARCH_DEBOUNCE_MS = 450;
  const backlog = [];
  const DEBUG_TRACE_KEY = 'myakm_w11_debug_trace_v1';
  const debugEnabled = new URLSearchParams(window.location.search).get('myakm_w11_debug') === '1';
  let flushTimer = null;
  let instrumentationStarted = false;

  const analyticsAllowed = () => {
    try {
      return Boolean(
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  };

  const readDebugTrace = () => {
    if (!debugEnabled) return [];
    try {
      const parsed = JSON.parse(window.sessionStorage.getItem(DEBUG_TRACE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeDebugTrace = (entry) => {
    if (!debugEnabled || !analyticsAllowed()) return;
    try {
      const trace = readDebugTrace();
      trace.push(entry);
      window.sessionStorage.setItem(DEBUG_TRACE_KEY, JSON.stringify(trace.slice(-200)));
    } catch (error) {
    }
  };

  const clearDebugTrace = () => {
    try {
      window.sessionStorage.removeItem(DEBUG_TRACE_KEY);
    } catch (error) {
    }
  };

  const viewport = () => {
    const width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 600) return 'mobile';
    if (width < 1024) return 'tablet';
    return 'desktop';
  };

  const base = () => ({
    schema_version: VERSION,
    journey: 'WHOLESALE',
    page_path: window.location.pathname.slice(0, 100),
    locale: document.documentElement.lang || '',
    viewport: viewport()
  });

  const safeText = (value, max = 120) => String(value || '').trim().slice(0, max);

  const sanitizeSearchTerm = (value) => {
    const text = safeText(value, 100);
    if (!text) return '';
    const hasEmail = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(text);
    const hasEgyptMobile = /(?:^|\D)(?:\+?20|0)1[0125]\d{8}(?:\D|$)/.test(text.replace(/[\s()-]/g, ''));
    return hasEmail || hasEgyptMobile ? '[redacted_pii]' : text;
  };

  const publishNow = (name, payload) => {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return false;
    try {
      const result = Shopify.analytics.publish(NS + name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return true;
    } catch (error) {
      return false;
    }
  };

  const flush = () => {
    if (!backlog.length) return;
    const pending = backlog.splice(0, backlog.length);
    pending.forEach((entry) => {
      if (!publishNow(entry.name, entry.payload)) backlog.push(entry);
    });
    if (!backlog.length && flushTimer) {
      window.clearInterval(flushTimer);
      flushTimer = null;
    }
  };

  const track = (name, data = {}) => {
    if (!analyticsAllowed()) return false;

    const payload = Object.assign(base(), data);
    if (!publishNow(name, payload)) {
      backlog.push({ name, payload });
      if (!flushTimer) {
        flushTimer = window.setInterval(flush, 500);
        window.setTimeout(() => {
          if (flushTimer) window.clearInterval(flushTimer);
          flushTimer = null;
          backlog.length = 0;
        }, 10000);
      }
    }

    const traceEntry = { name, payload, timestamp: new Date().toISOString() };
    writeDebugTrace(traceEntry);
    document.dispatchEvent(new CustomEvent('myakm:w11-event', { detail: traceEntry }));

    if ((debugEnabled || window.__MYAKM_W11_DEBUG__ === true) && window.console) {
      console.info('[MYAKM W11]', name, payload);
    }
    return true;
  };

  const quoteItems = () => {
    if (window.MYAKMWholesaleQuote && typeof window.MYAKMWholesaleQuote.getItems === 'function') {
      return window.MYAKMWholesaleQuote.getItems();
    }
    try {
      const parsed = JSON.parse(window.localStorage.getItem('myakm_wholesale_quote_v1') || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const itemDataFromButton = (button) => ({
    source_record_id: safeText(button && button.dataset.quoteSourceRecordId, 40),
    accounting_code: safeText(button && button.dataset.quoteCode, 80),
    category: safeText(button && button.dataset.quoteCategory, 100)
  });

  const quoteKey = (item) => {
    if (item && item.sourceRecordId) return 'source:' + item.sourceRecordId;
    return 'fallback:' + [item && item.code || '', item && item.title || '', item && item.category || ''].join('|');
  };

  const queryType = (term) => {
    if (!term) return 'category_only';
    if (/^[A-Za-z0-9._\/-]+$/.test(term) && /\d/.test(term)) return 'code_like';
    return 'text';
  };

  const initSearch = () => {
    document.querySelectorAll('.myakm-wholesale-hub').forEach((root) => {
      if (root.dataset.w11SearchReady === 'true') return;
      const search = root.querySelector('[data-wholesale-search]');
      const category = root.querySelector('[data-wholesale-category-filter]');
      const resultsList = root.querySelector('[data-wholesale-results-list]');
      const resultsStatus = root.querySelector('[data-wholesale-results-status]');
      const noResults = root.querySelector('[data-wholesale-no-results]');
      if (!search || !category || !resultsList || !resultsStatus || !noResults) return;

      let timer = null;
      let lastSignature = '';

      const measure = () => {
        timer = null;
        const raw = safeText(search.value, 120);
        const selectedCategory = safeText(category.value, 100);
        if (raw.length < 2 && !selectedCategory) return;

        const searchTerm = sanitizeSearchTerm(raw);
        const shownCount = resultsList.children.length;
        const noResult = noResults.hidden === false;
        const statusText = safeText(resultsStatus.textContent, 160);
        const hasMore = statusText.includes('أقرب 8');
        const exactCodeMatch = Array.from(resultsList.querySelectorAll('[data-quote-code]')).some((node) =>
          safeText(node.dataset.quoteCode, 80).toLowerCase() === raw.toLowerCase()
        );
        const signature = [searchTerm, selectedCategory, shownCount, noResult, hasMore].join('|');
        if (signature === lastSignature) return;
        lastSignature = signature;

        const data = {
          search_term: searchTerm,
          search_term_length: raw.length,
          search_type: queryType(raw),
          category: selectedCategory,
          result_count_shown: shownCount,
          result_bucket: noResult ? '0' : (hasMore ? '9_plus' : String(shownCount)),
          exact_code_match: exactCodeMatch
        };

        track('wholesale_search', data);
        if (noResult) track('wholesale_zero_result', data);
      };

      const schedule = () => {
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(measure, SEARCH_DEBOUNCE_MS);
      };

      search.addEventListener('input', schedule);
      category.addEventListener('change', schedule);
      root.dataset.w11SearchReady = 'true';
    });
  };

  const initPageViews = () => {
    const hub = document.querySelector('.myakm-wholesale-hub');
    if (hub) track('wholesale_hub_viewed');

    const pdp = document.querySelector('.myakm-wholesale-pdp');
    if (pdp) {
      const button = pdp.querySelector('[data-quote-add]');
      track('wholesale_pdp_viewed', itemDataFromButton(button));
    }

    if (document.querySelector('[data-wholesale-quote-list]')) {
      track('wholesale_quote_list_viewed', { item_count: quoteItems().length });
    }

    if (document.querySelector('[data-wholesale-rfq]')) {
      track('wholesale_rfq_viewed', { item_count: quoteItems().length });
    }
  };

  const initSuccessStates = () => {
    const hubSuccess = document.querySelector('.myakm-wholesale-hub__form-message--success');
    if (hubSuccess) track('wholesale_lead_submit_success', { quote_item_count: quoteItems().length });

    const rfqRoot = document.querySelector('[data-wholesale-rfq]');
    if (rfqRoot && rfqRoot.querySelector('[data-rfq-success]')) {
      track('wholesale_rfq_submit_success', {
        handoff_mode: 'whatsapp_plus_shopify_contact'
      });
    }
  };

  const initGlobalListeners = () => {
    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-quote-add]');
      if (addButton) {
        const items = quoteItems();
        const sourceRecordId = safeText(addButton.dataset.quoteSourceRecordId, 40);
        const existing = items.find((item) => sourceRecordId && safeText(item.sourceRecordId, 40) === sourceRecordId);
        const hub = addButton.closest('.myakm-wholesale-hub');
        const search = hub && hub.querySelector('[data-wholesale-search]');
        track('wholesale_quote_add', Object.assign(itemDataFromButton(addButton), {
          source_surface: addButton.closest('.myakm-wholesale-pdp') ? 'pdp' : (hub ? 'search' : 'other'),
          quote_item_count_before: items.length,
          action_type: existing ? 'increase_quantity' : 'add_new',
          search_term: hub && search ? sanitizeSearchTerm(search.value) : ''
        }));
        return;
      }

      const removeButton = event.target.closest('[data-quote-remove]');
      if (removeButton) {
        const items = quoteItems();
        const item = items.find((entry) => quoteKey(entry) === removeButton.dataset.quoteRemove);
        track('wholesale_quote_remove', {
          source_record_id: safeText(item && item.sourceRecordId, 40),
          accounting_code: safeText(item && item.code, 80),
          category: safeText(item && item.category, 100),
          quote_item_count_before: items.length
        });
        return;
      }

      const clearButton = event.target.closest('[data-quote-clear]');
      if (clearButton) {
        track('wholesale_quote_clear', { quote_item_count_before: quoteItems().length });
        return;
      }

      const continueButton = event.target.closest('[data-quote-next]');
      if (continueButton) {
        track('wholesale_quote_continue', { item_count: quoteItems().length });
        return;
      }

      const manualButton = event.target.closest('[data-wholesale-manual]');
      if (manualButton) {
        const hub = manualButton.closest('.myakm-wholesale-hub');
        const search = hub && hub.querySelector('[data-wholesale-search]');
        const category = hub && hub.querySelector('[data-wholesale-category-filter]');
        track('wholesale_zero_result_request', {
          search_term: sanitizeSearchTerm(search && search.value),
          category: safeText(category && category.value, 100)
        });
      }
    }, true);

    document.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('[data-quote-quantity]');
      if (!quantityInput) return;
      const items = quoteItems();
      const item = items.find((entry) => quoteKey(entry) === quantityInput.dataset.quoteQuantity);
      track('wholesale_quote_quantity_change', {
        source_record_id: safeText(item && item.sourceRecordId, 40),
        accounting_code: safeText(item && item.code, 80),
        category: safeText(item && item.category, 100),
        quantity: Math.max(1, Math.min(9999, Number.parseInt(quantityInput.value, 10) || 1))
      });
    }, true);

    document.addEventListener('toggle', (event) => {
      const details = event.target.closest && event.target.closest('.myakm-wholesale-rfq__full');
      if (details && details.open) track('wholesale_rfq_details_opened', { item_count: quoteItems().length });
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (form.matches('#myakm-wholesale-contact')) {
        track('wholesale_lead_submit_attempt', {
          quote_item_count: quoteItems().length,
          request_mode: quoteItems().length ? 'quote_context' : 'manual_or_single'
        });
        return;
      }

      if (form.matches('[data-rfq-form]')) {
        const root = form.closest('[data-wholesale-rfq]');
        const details = root && root.querySelector('.myakm-wholesale-rfq__full');
        track('wholesale_rfq_submit_attempt', {
          item_count: quoteItems().length,
          expanded_details_open: Boolean(details && details.open),
          attachment_mode: 'external_link_optional',
          handoff_mode: 'whatsapp_plus_shopify_contact'
        });
        return;
      }

    }, true);
  };

  const init = () => {
    if (instrumentationStarted || !analyticsAllowed()) return;
    instrumentationStarted = true;
    initGlobalListeners();
    initSearch();
    initPageViews();
    initSuccessStates();
  };

  const startWhenReady = () => {
    if (analyticsAllowed()) init();
  };

  const bootstrapPrivacy = () => {
    if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
      startWhenReady();
      return;
    }

    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (!error) startWhenReady();
        }
      );
    }
  };

  document.addEventListener('visitorConsentCollected', () => {
    if (analyticsAllowed()) init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapPrivacy, { once: true });
  } else {
    bootstrapPrivacy();
  }

  document.addEventListener('shopify:section:load', () => {
    if (!analyticsAllowed()) return;
    initSearch();
  });

  window.MYAKMW11Analytics = {
    track,
    version: VERSION,
    debugEnabled,
    analyticsAllowed,
    getDebugTrace: readDebugTrace,
    clearDebugTrace
  };
})();